import { render, staticRenderFns } from "./ClosedTradeDataTable.vue?vue&type=template&id=4f08c0d8"
import script from "./ClosedTradeDataTable.vue?vue&type=script&lang=js"
export * from "./ClosedTradeDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports